import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Outlet, Link } from "react-router-dom";
import ErrorBoundary from './Error';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useNavigate } from "react-router-dom";


const NavManager = (props) => {
  const navigate = useNavigate()
  
  const fnlogout=()=>{
    localStorage.removeItem("jwt");
    props.setLogin(false);
    navigate('/login')

  }

  if (props.isLoggedIn == undefined || !props.isLoggedIn) {
    return (
      <Nav.Link href="#login" ></Nav.Link>
    )
  }
  return (
    <>
      <Navbar expand="lg" className="bg-body-tertiary" bg="light" data-bs-theme="dark">
        <Container>
          <Navbar.Brand>TaskManager</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <NavDropdown title="Employees" id="basic-nav-dropdown">
                <NavDropdown.Item>
                  <Link className="nav-link" to="/employee/list">List</Link>
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action/3.2">
                  <Link className="nav-link" to="/employee/create">Create</Link>
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Client" id="basic-nav-dropdown">
                <NavDropdown.Item>
                  <Link className="nav-link" to="/client/list">List</Link>
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item>
                  <Link className="nav-link" to="/client/create">Create</Link>
                </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title="Tasks" id="basic-nav-dropdown">
                <NavDropdown.Item>
                  <Link className="nav-link" to="/tasks/list">List</Link>
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item>
                  <Link className="nav-link" to="/tasks/create">Create</Link>
                </NavDropdown.Item>
              </NavDropdown>

            </Nav>

            <Nav className="justify-content-end" activeKey="/home">
              <Nav.Item>
                <Button variant="primary" onClick={fnlogout}>
                  Logout
                </Button>              
              </Nav.Item>
            </Nav>

          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Outlet />
      {/* <ErrorBoundary>
        <Outlet />
      </ErrorBoundary> */}
    </>
  );
}

export default NavManager;